import type {
  ImportCustomFieldGroupsSelection,
  TSelectedLayoutEntry,
} from 'react-lib/components/organisms/ImportCustomFieldGroups';

function countEntryFields(entry: TSelectedLayoutEntry): number {
  return entry.type === 'GROUP' ? entry.items.length : 1;
}

export function countSelectedFields(selection: ImportCustomFieldGroupsSelection): number {
  return selection.sources
    .flatMap((source) => source.fieldsLayout)
    .reduce((total, entry) => total + countEntryFields(entry), 0);
}
